<template>
  <ul class="pagination">
    <li>
      <a :href="params.link">|&lt;</a>
    </li>

    <li v-if="(params.currentPage - 1) > 0">
      <a :href="linkWithPage + (params.currentPage - 1)">&lt;</a>
    </li>

    <li
      v-for="(page, index) in pages"
      :key="`page-${page}`"
      :data-index="index + 1"
      :class="{ 'active': page === params.currentPage }">
      <a :href="linkWithPage + page">{{ page }}</a>
    </li>

    <li v-if="params.currentPage < params.lastPage">
      <a :href="linkWithPage + (params.currentPage + 1)">&gt;</a>
    </li>

    <li>
      <a :href="linkWithPage + params.lastPage">&gt;|</a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'HiddenPagination',

  props: {
    /**
     * Объект с параметрами типа
     * {
     *   link: 'http://example.com',
     *   currentPage: 1,
     *   lastPage: 1,
     * }
     */
    params: {
      type: Object,
      required: true,
    },
  },

  computed: {
    pages() {
      return Array.from({ length: this.params.lastPage }, (_, index) => index + 1);
    },

    linkWithPage() {
      return `${this.params.link}?page=`;
    },
  },
};
</script>

<style scoped lang="scss">
  .pagination {
    display: none;
  }
</style>
